module.exports = __webpack_public_path__ + "static/img/logo.e11f1963.png";